import $ from 'jquery';

import 'bootstrap';
import 'slick-carousel';

import '../scss/style.scss';

$(function () {
    $('input.radio-button').on('change', function () {
        var value = $('input.radio-button:checked', $(this).parent()).val();
        $('.text-input-hidden', $(this).parent().parent()).val(value).change().trigger('blur');
        if ($('.text-input-hidden', $(this).parent().parent()).hasClass('error')) {
            var id = $('.text-input-hidden', $(this).parent().parent()).attr('id');
            window.jQuery('form').validate().element('#' + id);
        }
    });

    $('input[name=radioButtonTipoDocumento]').on('change', function () {
        /*
        jQuery("#textBoxNumeroDocumento").rules('remove', 'minlength');
        jQuery("#textBoxNumeroDocumento").rules('remove', 'maxlength');
        var tipoDocumento = $(this).val();
        if (tipoDocumento == "DNI")
            jQuery("#textBoxNumeroDocumento").rules('add', {minlength: 8, maxlength: 8, messages: {minlength: "El DNI debe contener solo 8 números.", maxlength: "El DNI debe contener solo 8 números."}});
        if (tipoDocumento == "RUC")
            jQuery("#textBoxNumeroDocumento").rules('add', {minlength: 11, maxlength: 11, messages: {minlength: "El RUC debe contener solo 11 números.", maxlength: "El RUC debe contener solo 11 números."}});
        */
    });

    $('button[data-href]').on('click', function (event) {
        var href = $(this).data('href');
        event.preventDefault();
        window.location.href = href;
    });
});

window.checkCaptcha = function (response) {
    window.jQuery('input[name=hiddenRecaptcha]').val(response)
    window.jQuery('form').validate().element('#hiddenRecaptcha');
};
